import { DatePipe } from '@angular/common';
import { Component, Input } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { IsQuoteOldPipe } from '@zero/shared/ui-pipes';
import { OrderDirection } from '@zero/shared/util-models';

@Component({
  selector: 'trade-create-header',
  templateUrl: './trade-create-header.component.html',
  imports: [DatePipe, IsQuoteOldPipe, TranslocoPipe],
})
export class TradeCreateHeaderComponent {
  @Input() public direction: OrderDirection = 'buy';
  @Input() public marketPlace?: string;
  @Input() public quoteTime?: string;
}
